module.exports = __webpack_public_path__ + "static/media/areia2.68bd5cc6.jpg";